import React, { useEffect } from "react";
import { Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@deere/fuel-react";
import { DEFAULT_LANGUAGE_CODE, HELP_TEXT_TRANSLATION_PLACEHOLDER } from "../../../../utils/surveyLiterals";
import { sortByLanguageList } from "../../../../utils/utils";

const HelpTextTranslationsTab = ({ payloadData, setPayloadData, selectedSec, que, languageList }) => {
  const payloadLanguages = payloadData && payloadData.language ? payloadData.language.filter((hd) => hd.languageCd !== DEFAULT_LANGUAGE_CODE) : [];

  useEffect(() => {
    if (payloadData.language) {
      setPayloadData((prevState) => {
        const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
        const newSections = [...prevState.sections];
        const newQuestions = [...newSections[sectionIndex].questions];
        const questionIndex = newQuestions.findIndex((nq) => nq.code === que.code);
        const newTranslations = [...newQuestions[questionIndex].translations];
        payloadLanguages.forEach((pl) => {
          const index = newTranslations.findIndex((nt) => nt.locale === pl.languageCd);
          if (index > -1) newTranslations[index].language = pl.text;
          else newTranslations.push({ locale: pl.languageCd, language: pl.text, text: "", helpText: "" });
        });
        newQuestions[questionIndex] = { ...newQuestions[questionIndex], translations: newTranslations };
        newSections[sectionIndex] = { ...newSections[sectionIndex], questions: newQuestions };
        return { ...prevState, sections: newSections };
      });
    }
  }, [payloadData.language]);

  const changeHandler = (e, langCode) => {
    setPayloadData((prevState) => {
      const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
      const newSections = [...prevState.sections];
      const newQuestions = [...newSections[sectionIndex].questions];
      const questionIndex = newQuestions.findIndex((nq) => nq.code === que.code);
      const newTranslations = [...newQuestions[questionIndex].translations];
      const translationIndex = newTranslations.findIndex((trn) => trn.locale === langCode);
      newTranslations[translationIndex].helpText = e.target.value;
      newQuestions[questionIndex] = { ...newQuestions[questionIndex], translations: newTranslations };
      newSections[sectionIndex] = { ...newSections[sectionIndex], questions: newQuestions };
      return { ...prevState, sections: newSections };
    });
  };

  return (
    <Grid container mt={4} spacing={4}>
      <Table size="small">
        <TableHead sx={{ border: "none" }}>
          <TableRow>
            <TableCell>Label</TableCell>
            <TableCell>Language</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortByLanguageList(que.translations, languageList).map((tr) => (
            <TableRow key={tr.locale} sx={{ border: "none!important" }}>
              <TableCell>
                <TextField required placeholder={HELP_TEXT_TRANSLATION_PLACEHOLDER} onChange={(e) => changeHandler(e, tr.locale)} value={tr.helpText} />
              </TableCell>
              <TableCell>{tr.language}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Grid>
  );
};

export default HelpTextTranslationsTab;
